export default __webpack_public_path__ + "static/media/cool.bfc86c3d.svg";